// Popup de horario de funcionamento — abre ao clicar no status da loja.
// Existe separado do modal "Informacoes da Loja" (que tem endereco, pagamentos
// e redes) porque quem clica em "Fechado · abre 18:00" quer UMA coisa: saber
// os horarios. Um modal com seis secoes obriga a procurar.

import { X } from "lucide-react";

import { DIAS, hojeIdx, horarioDoDia } from "../lib/businessHours";

export default function HorariosModal({ businessHours, t, darkMode, onClose }) {
  const hoje = hojeIdx();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className={`w-full max-w-md rounded-2xl ${t.bgCard} border ${t.border} shadow-2xl overflow-hidden`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Horário de funcionamento"
      >
        <div className={`flex items-center justify-between px-5 py-3.5 border-b ${t.border}`}>
          <h2 className={`font-bold ${t.text}`}>Horário de funcionamento</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar"
            className={`w-8 h-8 rounded-lg flex items-center justify-center ${t.textMuted} hover:bg-black/5 dark:hover:bg-white/10 transition-colors`}
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="px-5 py-3">
          {DIAS.map((dia, idx) => {
            const d = horarioDoDia(businessHours, idx);
            const eHoje = idx === hoje;
            return (
              <div
                key={dia}
                className={`flex items-baseline justify-between gap-4 py-2 ${
                  idx < DIAS.length - 1 ? `border-b ${t.border}` : ""
                }`}
              >
                <span className={`text-sm ${eHoje ? `font-bold ${t.text}` : t.textMuted}`}>
                  {dia}
                  {eHoje && (
                    <span className={`ml-2 text-[10px] font-semibold uppercase tracking-wide ${darkMode ? "text-orange-400" : "text-orange-600"}`}>
                      hoje
                    </span>
                  )}
                </span>
                <span className={`text-sm ${d.aberto ? (eHoje ? `font-semibold ${t.text}` : t.text) : t.textMuted2}`}>
                  {d.texto}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
